module.exports = __webpack_public_path__ + "img/39_13.5e28cfdd.png";